import BaseModel from './base';

export default class GroupAge extends BaseModel {
  constructor(age, url) {
    super(age, url);

    this.min_age = age.min_age;
    this.max_age = age.max_age;

    this.event_stage_id = age.event_stage_id;
    this.event_group_id = age.event_group_id;
  }
}
